import { DateLocale } from "../i18n.models";

type FormatLongWidth = "full" | "long" | "medium" | "short";

export const patchDateLocale = (locale: DateLocale, args: { formats: Record<FormatLongWidth, string>; defaultWidth: FormatLongWidth }): void => {
  locale.formatLong.date = function (options: { width?: FormatLongWidth } = {}): string {
    const width = options.width || args.defaultWidth;
    return args.formats[width] || args.formats[args.defaultWidth];
  };
};
